import React from "react";
import * as PropTypes from "prop-types";
import DateUtils from '../../../../../monitoring/src/Utils/DateUtils';

export function PhotoDescription(props) {
	const {photo = null, dateFormat = 'yyyy/MM/dd hh:mm aa'} = props;

	if(photo == null) {
		return <div className="photo-description">
			<span>&nbsp;</span>
		</div>
	}
	
	if(!photo?.photoId) {
		return <div className="photo-description empty">
			<span className="title">(No Photo Available)</span>
			<span>&nbsp;</span>
		</div>
	}

	return <div className="photo-description">
		<span className="title">{photo?.sampleEventName}</span>
		<span>{DateUtils.FormatToLocalDateTime(photo?.created, dateFormat)}</span>
	</div>;
}

PhotoDescription.propTypes = {
	photo: PropTypes.any,
	dateFormat: PropTypes.string,
};
